import { RequestState } from './utils/state-manager';

export type CurrentUserState = {
  user: AuthenticatedUser;
  userStatus: RequestState;
  userSharedEmails: Array<string>;
  userSharedEmailsStatus: RequestState;
};

type State = { user: CurrentUserState };
export const userStatusSelector = (state: State) => state.user.userStatus;
export const userSelector = (state: State) => state.user.user;
export const userSharedEmailsSelector = (state: State) => state.user.userSharedEmails;
